import React from "react";
import styled from "styled-components";
import { Media } from "./Media";

const Container = styled.div`
  > div {
    display: flex;
  }
`;

const StyledSvg = styled.svg`
  transform: ${({ $transformProp }) => $transformProp};
`;

export const ArrowContainer = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    $backgroundColour ? theme.colours[$backgroundColour] : theme.colours.black};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (${({ theme }) => theme.mq.m}) {
    width: ${({ large }) => (large ? "96px" : "48px")};
    height: ${({ large }) => (large ? "96px" : "48px")};
  }
`;

export const arrowHoverStyles = `
  > div:first-child {
    animation: scaleOut ease 0.1s; 
    animation-fill-mode: forwards;     
  }
  &:hover {
    a {
      color: ${({ theme }) => theme.colours.blue};
    }
    > div:first-child {
      animation: scaleIn ease 0.2s; 
      animation-fill-mode: forwards;     
    }
  }
`;

function Arrow({ large, colour, isLong, transform }) {
  if (isLong) {
    return (
      <StyledSvg
        $transformProp={transform}
        width="43"
        height="72"
        viewBox="0 0 43 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={colour}
          d="M21.5203 71.4799C21.5316 71.491 21.5497 71.491 21.561 71.4799L41.7806 51.4917C42.1766 51.1002 42.1766 50.4608 41.7807 50.0694L40.8926 49.1913C40.503 48.8061 39.8761 48.8061 39.4865 49.1912L25.0519 63.4601C24.4203 64.0844 23.3489 63.637 23.3489 62.7489L23.3489 1.5C23.3489 0.947717 22.9012 0.499999 22.3489 0.499999L21.0807 0.499999C20.5284 0.499999 20.0807 0.947714 20.0807 1.5L20.0806 63.1736C20.0806 64.0617 19.0092 64.5092 18.3776 63.8848L3.51351 49.1912C3.12391 48.8061 2.49698 48.8061 2.10742 49.1913L1.2193 50.0694C0.823381 50.4608 0.8234 51.1002 1.21935 51.4917L21.439 71.4799C21.4503 71.491 21.4684 71.491 21.4797 71.4799C21.4909 71.4688 21.5091 71.4688 21.5203 71.4799Z"
        />
      </StyledSvg>
    );
  }

  return (
    <Container>
      <Media greaterThanOrEqual="m">
        <StyledSvg
          $transformProp={transform}
          width={large ? 42 : 28}
          height={large ? 42 : 28}
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={colour}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.7016 19.5735C40.3106 19.1802 39.6743 19.1802 39.2833 19.5735L24.1321 34.8118C23.5027 35.4448 22.4224 34.9987 22.4229 34.1061L22.4445 1.00169C22.4449 0.449367 21.9974 0.00134692 21.4451 0.00103582L20.6061 0.000563219C20.0538 0.000252154 19.6059 0.447661 19.6055 0.99991L19.5839 34.1142C19.5833 35.0062 18.5037 35.4512 17.8748 34.8187L2.71669 19.5735C2.32571 19.1802 1.68941 19.1802 1.29843 19.5735L0.70106 20.1742C0.313228 20.5643 0.313224 21.1943 0.701053 21.5844L19.5648 40.5566C19.5746 40.5665 19.5802 40.58 19.5802 40.5939C19.5801 40.6228 19.6036 40.6465 19.6325 40.6465C19.6464 40.6465 19.6598 40.6521 19.6696 40.662L20.2909 41.2868C20.6819 41.68 21.3181 41.68 21.7091 41.2868L22.3288 40.6635C22.3388 40.6535 22.3523 40.6479 22.3663 40.6479C22.3955 40.6479 22.4192 40.6239 22.4192 40.5948C22.4192 40.5807 22.4248 40.567 22.4347 40.557L41.2989 21.5844C41.6868 21.1943 41.6868 20.5643 41.2989 20.1742L40.7016 19.5735Z"
          />
        </StyledSvg>
      </Media>
      <Media lessThan="m">
        <StyledSvg
          $transformProp={transform}
          width={28}
          height={28}
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={colour}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.7016 19.5735C40.3106 19.1802 39.6743 19.1802 39.2833 19.5735L24.1321 34.8118C23.5027 35.4448 22.4224 34.9987 22.4229 34.1061L22.4445 1.00169C22.4449 0.449367 21.9974 0.00134692 21.4451 0.00103582L20.6061 0.000563219C20.0538 0.000252154 19.6059 0.447661 19.6055 0.99991L19.5839 34.1142C19.5833 35.0062 18.5037 35.4512 17.8748 34.8187L2.71669 19.5735C2.32571 19.1802 1.68941 19.1802 1.29843 19.5735L0.70106 20.1742C0.313228 20.5643 0.313224 21.1943 0.701053 21.5844L19.5648 40.5566C19.5746 40.5665 19.5802 40.58 19.5802 40.5939C19.5801 40.6228 19.6036 40.6465 19.6325 40.6465C19.6464 40.6465 19.6598 40.6521 19.6696 40.662L20.2909 41.2868C20.6819 41.68 21.3181 41.68 21.7091 41.2868L22.3288 40.6635C22.3388 40.6535 22.3523 40.6479 22.3663 40.6479C22.3955 40.6479 22.4192 40.6239 22.4192 40.5948C22.4192 40.5807 22.4248 40.567 22.4347 40.557L41.2989 21.5844C41.6868 21.1943 41.6868 20.5643 41.2989 20.1742L40.7016 19.5735Z"
          />
        </StyledSvg>
      </Media>
    </Container>
  );
}

export default Arrow;
